// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useParams, useNavigate } from "react-router-dom";

// function WorkerDashboardPage() {
//   const { id } = useParams();
//   const [bills, setBills] = useState([]);
//   const [productStats, setProductStats] = useState({});
//   const [workerName, setWorkerName] = useState("");

//   const API_WORKERS = "http://localhost/murugan/worker/get_all.php";

//   // Fetch worker name by ID
//   const fetchWorkerName = async () => {
//     try {
//       const res = await axios.get(API_WORKERS);
//       const workers = res.data;

//       const worker = workers.find((w) => w.id === id);
//       if (worker) {
//         setWorkerName(worker.username);
//       } else {
//         setWorkerName("Unknown");
//       }
//     } catch (error) {
//       console.error("Failed to fetch worker name:", error);
//       setWorkerName("Unknown");
//     }
//   };

//   // Fetch bills
//   const fetchBills = async () => {
//     try {
//       const res = await axios.get(
//         `http://localhost/murugan/bills/get_by_worker.php?worker_id=${id}`
//       );
//       const usageBills = res.data.filter((bill) => bill.type !== "deduction");
//       setBills(usageBills);

//       const productCount = {};
//       res.data.forEach((bill) => {
//         bill.items.forEach((item) => {
//           if (!productCount[item.product]) {
//             productCount[item.product] = 0;
//           }
//           productCount[item.product] += item.quantity;
//         });
//       });
//       setProductStats(productCount);
//     } catch (err) {
//       console.error("Failed to fetch bills", err);
//     }
//   };

//   useEffect(() => {
//     fetchWorkerName();
//     fetchBills();
//   }, [id]);

//   return (
//     <div className="min-h-screen flex bg-white overflow-hidden">
//       <div className="flex-1 flex flex-col">
//         <main className="p-6">
//           <h2 className="text-green-700 mb-4 text-2xl font-semibold">
//             👷 Worker Dashboard - {id} {workerName && `(${workerName})`}
//           </h2>

//           {bills.length === 0 ? (
//             <p className="text-center text-gray-500">
//               No bills found for this worker.
//             </p>
//           ) : (
//             <div
//               className="overflow-auto"
//               style={{ maxHeight: "70vh", paddingRight: "10px" }}
//             >
//               {bills.map((bill) => (
//                 <div key={bill._id || bill.id} className="card mb-4 shadow-sm">
//                   <div className="card-body">
//                     <h5 className="mb-3 text-blue-600">
//                       🧾 Bill Date: {new Date(bill.date).toLocaleDateString()}
//                     </h5>

//                     <div className="table-responsive">
//                       <table className="table table-bordered table-striped align-middle">
//                         <thead className="table-success">
//                           <tr>
//                             <th>Product</th>
//                             <th>Quantity</th>
//                             <th>Price (₹)</th>
//                             <th>Total (₹)</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {bill.items.map((item, index) => (
//                             <tr key={index}>
//                               <td>{item.product}</td>
//                               <td>{item.quantity}</td>
//                               <td>{item.price}</td>
//                               <td>{item.price * item.quantity}</td>
//                             </tr>
//                           ))}
//                         </tbody>
//                       </table>
//                     </div>

//                     <div className="fw-bold text-end">
//                       Grand Total: ₹{bill.total}
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}
//         </main>
//       </div>
//     </div>
//   );
// }

// export default WorkerDashboardPage;

import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Api } from "../Api/Api";

function WorkerDashboardPage() {
  const { id } = useParams();
  const [bills, setBills] = useState([]);
  const [workerName, setWorkerName] = useState("");

  const API_WORKERS = `${Api}worker/get_all.php`;

  // Fetch worker name by ID
  const fetchWorkerName = async () => {
    try {
      const res = await axios.get(API_WORKERS);
      const workers = res.data;
      const worker = workers.find((w) => String(w.id) === String(id));
      setWorkerName(worker ? worker.username : "Unknown");
    } catch (error) {
      console.error("Failed to fetch worker name:", error);
      setWorkerName("Unknown");
    }
  };

  // Fetch bills
  const fetchBills = async () => {
    try {
      const res = await axios.get(
        `${Api}bills/get_by_worker.php?worker_id=${id}`
      );
      console.log(res.data);
      const usageBills = res.data.filter((bill) => bill.type !== "deduction");
      setBills(usageBills);
    } catch (err) {
      console.error("Failed to fetch bills", err);
    }
  };

  useEffect(() => {
    fetchWorkerName();
    fetchBills();
  }, [id]);

  return (
    <div className="min-h-screen bg-white p-4">
      <h2 className="text-green-700 mb-4 text-2xl font-semibold">
        👷 Worker Dashboard - {id} {workerName && `(${workerName})`}
      </h2>

      {bills.length === 0 ? (
        <p className="text-center text-gray-500">
          No bills found for this worker.
        </p>
      ) : (
        <div className="overflow-x-auto" style={{ maxHeight: "75vh" }}>
          <table className="min-w-full border border-gray-300 text-sm md:text-base">
            <thead className="bg-green-600 text-white">
              <tr>
                <th className="py-2 px-4 border">S.No</th>
                <th className="py-2 px-4 border">Date</th>
                <th className="py-2 px-4 border">Invoice No</th>
                <th className="py-2 px-4 border">Product</th>
                <th className="py-2 px-4 border">Qty</th>
                <th className="py-2 px-4 border">Price (₹)</th>
                <th className="py-2 px-4 border">Subtotal (₹)</th>

                <th className="py-2 px-4 border">Grand Total (₹)</th>
              </tr>
            </thead>

            <tbody>
              {bills.map((bill, billIndex) =>
                bill.items.map((item, itemIndex) => (
                  <tr
                    key={`${billIndex}-${itemIndex}`}
                    className="hover:bg-green-50"
                  >
                    {/* S.No only on first row of bill */}
                    {itemIndex === 0 && (
                      <td
                        className="py-2 px-4 border text-center"
                        rowSpan={bill.items.length}
                      >
                        {billIndex + 1}
                      </td>
                    )}

                    {/* Date */}
                    {itemIndex === 0 && (
                      <td
                        className="border border-gray-300 px-4 py-2"
                        rowSpan={bill.items.length}
                      >
                        {bill.bill_date
                          ? new Date(bill.bill_date).toLocaleDateString("en-GB") // DD/MM/YYYY
                          : "N/A"}
                      </td>
                    )}

                    {/* Invoice No */}
                    {itemIndex === 0 && (
                      <td
                        className="py-2 px-4 border"
                        rowSpan={bill.items.length}
                      >
                        {bill.invoice_no}
                      </td>
                    )}

                    {/* Product row */}
                    <td className="py-2 px-4 border">{item.product}</td>
                    <td className="py-2 px-4 border text-center">
                      {item.quantity}
                    </td>
                    <td className="py-2 px-4 border">₹{item.price}</td>

                    {/* Totals (only once per bill, rowspan) */}
                    {itemIndex === 0 && (
                      <>
                        <td
                          className="py-2 px-4 border"
                          rowSpan={bill.items.length}
                        >
                          ₹{bill.subtotal}
                        </td>

                        <td
                          className="py-2 px-4 border text-green-700 font-bold"
                          rowSpan={bill.items.length}
                        >
                          ₹{bill.total}
                        </td>
                      </>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default WorkerDashboardPage;
